module.exports = __webpack_public_path__ + "static/media/aerospace.f844374c.svg";